<template>
  <div lazy-validation>
    <v-layout row>
      <v-flex xs12 sm10>
        <v-radio-group row v-model="type" :disabled="isEdit">
          <v-radio color="primary" label="Institucional" value="I"/>
          <v-radio color="primary" :label="'Niveles (' + selected.levels.length + ')'" value="N"/>
          <v-radio color="primary" :label="'Grupos (' + selected.ggs.length + ')'" value="G"/>
          <v-radio color="primary" :label="'Subgrupos (' + selected.subgroupIds.length + ')'" value="SG"/>
          <v-radio
            color="primary"
            :label="'Estudiantes (' + selected.students.length + ')'"
            value="E"
          />
        </v-radio-group>
      </v-flex>
      <v-flex xs12 sm3 class="titleSearch" justify-end style="margin-left: auto;">
        <v-text-field
          flat
          label="Buscar"
          append-outer-icon="search"
          clearable
          solo-inverted
          hide-details
          @keyup="searchStudents"
          @click:append-outer="searchStudents"
          @click:clear="clearSearch"
          v-model="search"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-slide-x-transition mode="out-in">
        <v-flex xs12 :key="3" v-if="type == 'I'">
          <v-layout justify-center align-center fill-height row wrap>
            <v-flex xs6>
              <v-alert
                style="border-radius:33px;"
                :value="true"
                type="info"
                color="gradiente"
              >Toda la institución será notificada</v-alert>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 :key="0" v-if="type == 'N'">
          <lSelection v-model="selected.levels" :array="filteredArray"/>
        </v-flex>
        <v-flex xs12 :key="1" v-if="type == 'G'">
          <gSelection v-model="selected.ggs" :array="filteredArray"/>
        </v-flex>
        <v-flex xs12 :key="3" v-if="type == 'SG'">
          <sgSelection v-model="selected.subgroupIds" :array="filteredArray"/>
        </v-flex>
        <v-flex xs12 :key="4" v-if="type == 'E'">
          <sSelection 
            v-model="selected.students" 
            :array="filteredArray"
            :showBtnScroll="showBtnScroll" 
            @viewMore="viewMoreClick"
          />
        </v-flex>
      </v-slide-x-transition>
    </v-layout>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import lSelection from "./LevelsSelection";
import gSelection from "./GGsSelection";
import sgSelection from "./SGsSelection";
import sSelection from "./StudentsSelection";
import cSelection from "./ColaboratorsSelection";
export default {
  components: {
    lSelection,
    gSelection,
    sSelection,
    sgSelection,
    cSelection
    
  },
  props: ["cancel", "_object", "isEdit"],
  data: () => ({
    search: "",
    type: "",
    selected: {
      levels: [],
      ggs: [],
      students: [],
      subgroupIds: [],
      institutional: false
    },
    studentsFilter: [],
    offset: 0,
    showBtnScroll: false,
    updateStudentsArea: false
  }),
  watch: {
    cancel() {
      if (this.cancel) {
        this.selected = {
          levels: [],
          ggs: [],
          subgroupIds: [],
          students: [],
          institutional: false
        };
      }
    },
    _object(){
      //PARA HACER LA EDICIÓN DE AUDIENCIA SE NECESITA TRAER LOS OBJETOS LLENOS (LEVELS, GROUPS, STUDENTS) NO SOLO TENER LOS ID'S
      if(this._object !== null) {
        if(this._object.audience.institutional){
          this.type = "I";
        } else if(this._object.levels.length > 0){
          this.type = "N";
          this.selected.levels = this._object.levels;
          this.selected.subgroupIds = [];
          this.selected.ggs = [];
          this.selected.students = [];
          this.selected.webRoleIds = [];
        } else if(this._object.groups.length > 0){
          this.type = "G";
          this.selected.levels = [];
          this.selected.subgroupIds = [];
          this.selected.ggs = this._object.groups;
          this.selected.students = [];
          this.selected.webRoleIds = [];
        } else if(this._object.subgroupIds.length > 0) {
          this.type = "SG";
          this.selected.levels = [];
          this.selected.subgroupIds = this._object.subgroupIds;
          this.selected.students = [];
          this.selected.ggs = [];
          this.selected.webRoleIds = [];
        } else if(this._object.students.length > 0){
          this.type = "E";
          this.selected.levels = [];
          this.selected.ggs = [];
          this.selected.subgroupIds = [];
          this.selected.webRoleIds = [];
          this.selected.students = this._object.students;
        } else {
          this.type = "I";
        }
      } else {
        this.type = "I";
      }
    },
    type: {
      handler() {
        switch (this.type) {
          case "I":
            this.selected.levels = [];
            this.selected.ggs = [];
            this.selected.students = [];
            this.selected.subgroupIds = [];
            this.selected.webRoleIds = [];
            this.selected.institutional = true;
            break;
          case "N":
            this.selected.ggs = [];
            this.selected.students = [];
            this.selected.subgroupIds = [];
            this.selected.webRoleIds = [];
            this.selected.institutional = false;
            break;
          case "G":
            this.selected.levels = [];
            this.selected.students = [];
            this.selected.subgroupIds = [];
            this.selected.webRoleIds = [];
            this.selected.institutional = false;
            break;
          case "SG":
            this.selected.levels = [];
            this.selected.students = [];
            this.selected.ggs = [];
            this.selected.webRoleIds = [];
            this.selected.institutional = false;
            break;
          case "E":
            this.selected.levels = [];
            this.selected.ggs = [];
            this.selected.webRoleIds = [];
            this.selected.subgroupIds = [];
            this.selected.institutional = false;
            this.getStudentsByBranch(false);
            break;
        }
      },
      deep: true,
    },
    selected: {
      handler() {
        this.deleteSelectedOfSearch();
        this.search = "";
        this.$emit("selected", this.selected);
      },
      deep: true,
    }
  },
  computed: {
    filteredArray() {
      var transformMap = {
        a: "[aá]",
        e: "[eé]",
        i: "[ií]",
        o: "[oó]",
        u: "[uí]",
        A: "[AÁ]",
        E: "[EÉ]",
        I: "[IÍ]",
        O: "[OÓ]",
        U: "[UÚ]",
      };
      var search = this.search ? this.search : "";
      search = search.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      for (var key in transformMap) {
        search = search.replace(key, transformMap[key]);
      }
      var matcher = new RegExp(search, "i");
      var array = [];
      var vm = this;
      
      switch (this.type) {
        case "N":
          array = this.levels.filter((value) => {
            for (var l in vm.selected.levels) {
              if (vm.selected.levels[l].id == value.id) {
                return false;
              }
            }
            return matcher.test([value.typeLevel].join());
          });
          break;
        case "G":
          array = this.ggs.filter((value) => {
            for (var g in vm.selected.ggs) {
              if (vm.selected.ggs[g].id == value.id) {
                return false;
              }
            }
            for (var l in vm.selected.levels) {
              if (vm.selected.levels[l].id == value.level.id) {
                return false;
              }
            }
            return matcher.test(
              [value.grade + " " + value.group, value.level.typeLevel].join()
            );
          });
          break;
        case "SG":
          array = Array.from(this.subgroupIds);
          break;
        case "E":
          array = this.studentsFilter;
          break;
      }
      return array;
    },
  },
  mounted() {
    this.getTools();
    this.getSubGroups();
    this.getStudentsByBranch(true);
  },
  methods: {
    viewMoreClick(){
      this.offset = this.offset + 20;
      this.getStudentsByBranch(true);
    },
    getStudentsByBranch(isScroll) {
      var params = {
        search: this.search,
        page_size: 20,
        offset: this.offset
      };
      this.$store
        .dispatch("student/getByBranch", params)
        .then((response) => {
          let posts = response.data;
          this.updateStudentsArea = true;
          if(isScroll){
            if(posts.length){
              this.studentsFilter = this.studentsFilter.concat(posts)
              this.showBtnScroll = true;
            } else {
              this.showBtnScroll = false;
            }
          } else {
            this.studentsFilter = posts;
            if(posts.length){
              this.showBtnScroll = true;
            } else {
              this.showBtnScroll = false;
            }
          }
          this.deleteSelectedOfSearch();
        })
        .catch(() => {});
    },
    getSubGroups(){
      this.$store
        .dispatch("notice/getSubgrupos")
        .then((response) => {
          this.subgroupIds = response.data;
        })
        .catch((error) => {
          console.log(error)
        });
    },
    getTools() {
      this.$store
        .dispatch("notice/getNoticeTools")
        .then((response) => {
          this.levels = response.data.entity.levels;
          this.ggs = response.data.entity.ggs;
        })
        .catch(() => {});
    },
    searchStudents(){
      if(this.type === "E"){
        this.offset = 0;
        this.getStudentsByBranch(false);
      }
    },
    clearSearch(){
      if(this.type === "E"){
        this.offset = 0;
        this.search = "";
        this.getStudentsByBranch(false);
      }
    },
    deleteSelectedOfSearch(){
      for (var s in this.selected.students) {
        for (var sf in this.studentsFilter) {
          if (this.selected.students[s].id == this.studentsFilter[sf].id) {
            this.studentsFilter.splice(sf, 1);
          }
        }
      }
    }
  },
};
</script>

<style>
label[for*="descriptionField"],
label[htmlfor*="descriptionField"] {
  top: 0;
  line-height: 13px !important;
}
</style>
